import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDogCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0046 12.3132L18.2905 9.81549C18.1635 9.63075 17.9946 9.47921 17.7979 9.37344C17.6013 9.26766 17.3824 9.21068 17.1596 9.20723L13.9067 9.16016H13.9C12.2206 9.16016 10.9321 9.44353 10.1022 10.8265C9.32958 12.1138 9 14.3066 9 18.1587V18.6294H10.0662L9.37987 22.1602H10.331L11.0174 18.6294H11.3333C12.0955 18.6363 12.8298 18.3405 13.3776 17.8058C13.8728 17.3278 14.23 16.6739 14.4106 15.9147L14.4123 15.9079L15.2127 12.0387H14.2592L13.5015 15.7015C13.2707 16.663 12.5807 17.6879 11.3333 17.6879H9.93508C9.96043 14.3553 10.2612 12.3795 10.9006 11.3139C11.4373 10.4195 12.2218 10.102 13.8968 10.1015L17.1462 10.1486C17.2205 10.1498 17.2934 10.1687 17.359 10.204C17.4245 10.2393 17.4808 10.2898 17.5231 10.3514L19.4621 13.1765L22.0667 13.6144V14.1134L21.6323 16.4502C21.5041 17.1399 21.285 17.4873 20.3864 17.5962L16.7025 18.232L16.6781 22.1602H17.6114L17.6309 19.0268L20.5096 18.5296C21.1618 18.4487 21.643 18.2367 21.9804 17.8816C22.2689 17.578 22.4444 17.1902 22.5497 16.6237L23 14.2009V12.8168L20.0046 12.3132Z",
			fill: "#4E289B"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16.1602,
			r: 12.5,
			stroke: "#451F92"
		})
	]
});
const ForwardRef = forwardRef(SvgDogCircle);
export { ForwardRef as ReactComponent };
